import { render } from "./DigitalMarketing.vue?vue&type=template&id=3ed37e7b&scoped=true"
import script from "./DigitalMarketing.vue?vue&type=script&lang=js"
export * from "./DigitalMarketing.vue?vue&type=script&lang=js"

import "./DigitalMarketing.vue?vue&type=style&index=0&id=3ed37e7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed37e7b"]])

export default __exports__